export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14500.04ff4c99.jpg";